import { render, staticRenderFns } from "./XxtdList.vue?vue&type=template&id=1a5a6fc2&scoped=true"
import script from "./XxtdList.vue?vue&type=script&lang=js"
export * from "./XxtdList.vue?vue&type=script&lang=js"
import style0 from "./XxtdList.vue?vue&type=style&index=0&id=1a5a6fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5a6fc2",
  null
  
)

export default component.exports